import { render, staticRenderFns } from "./MyInfoMarketingAgree.vue?vue&type=template&id=31eab55a&scoped=true"
import script from "./MyInfoMarketingAgree.vue?vue&type=script&lang=js"
export * from "./MyInfoMarketingAgree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eab55a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31eab55a')) {
      api.createRecord('31eab55a', component.options)
    } else {
      api.reload('31eab55a', component.options)
    }
    module.hot.accept("./MyInfoMarketingAgree.vue?vue&type=template&id=31eab55a&scoped=true", function () {
      api.rerender('31eab55a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/MyInfoMarketingAgree.vue"
export default component.exports